export const featuredProjects = [
  {
    title: "Koalo studio",
    description:
      "A custom web editor to allow users to get first hand experience of the app they can later buy from the official page, if they choose to get full functionality.",
    stack: [
      "ReactJS",
      "Firebase Storage",
      "Firebase cloud Firestore",
      "Stripe",
    ],
    link: ["", "https://dashboard.koalo.app/studio"],
  },
  {
    title: "Stereopark",
    description:
      "A music management dashboard for artists users that allow updating their public facing profile, manage their music contents (add new, update, or remove), manage billing (integrated with stripe for account on-boarding and managing products).",
    stack: ["NextJS", "Redux", "Firebase", "Stripe"],
    link: ["", "https://stereopark-artist-dashboard.vercel.app"],
  },
  {
    title: "Elegami",
    description:
      "A dynamic project management solution designed to enhance collaboration and efficiency. With intuitive task management, visual project planning, and real-time updates. Test the app using; Email: user1@example.com, Password: password",
    stack: ["Hotwire-rails", "Hotwire-stimulus", "Ruby on Rails", "PostgreSQL"],
    link: [
      "https://github.com/yonas44/Elegami",
      "https://elegami.onrender.com/",
    ],
  },
  {
    title: "Figsy",
    description:
      "Software platform with a focused mission to provide a convenient way for a client to connect with health/ nutrition professionals and enhance the monitoring of user's nutritional intake and consumption patterns. Upon completion, this platform will empower users to establish direct connections with their assigned nutritionists to get tailored guidance.",
    stack: [
      "React.js",
      "Redux",
      "Ruby on Rails",
      "JWT",
      "PostgreSQL",
      "WebSocket",
    ],
    link: ["", "https://figsy.vercel.app/"],
  },
];

export const otherProjects = [
  {
    title: "Quickchops",
    description:
      "A custom loyalty system that aims to enable companies to track customer interactions and branch performance,offering detailed analytics to address business needs and enhance retention.",
    stack: ["ReactJS", "Ruby on Rails", "Firebase(OTP)", "PostgreSQL"],
    link: ["", "https://quickchops.vercel.app/"],
  },
  {
    title: "Travelers Hub",
    description:
      "This app streamlines travel booking with registration and login features, allowing users to book pre-set packages or create their own. Users can reserve their dream vacation with a few clicks without the hassle of searching through multiple travel sites.",
    stack: ["React.js", "Redux", "Ruby on Rails", "JWT", "PostgreSQL"],
    link: ["https://github.com/yonas44/travelers_hub_back-end"],
  },
  {
    title: "Artex",
    description:
      "A conference website to display event program, featured speakers along with date of the event. It has two pages that shows the event and information about the event organizers.",
    stack: ["HTML5", "CSS3", "JavaScript"],
    link: [
      "https://github.com/yonas44/Artex-conference-website",
      "https://yonas44.github.io/Artex-conference-website/",
    ],
  },
];
